<template>
  <div>
    <embed-api-table
      title="Questionnaires"
      module="Questionnaires"
      add-new-text="Add New Questionnaire"
      default-sort="createdAt ASC"
      v-bind:columns="qColumns"
      v-bind:filter="qFilter">
    </embed-api-table>
    
  </div>
</template>

<script>
  import EmbedApiTable from "./EmbedApiTable.vue";
  import WebLLCRESTApi from "../api/api";
  
  export default {
    data() {
      return {
        qColumns: [
          { key: "type", "text": "Type", type: "String" },
          { key: "createdAt", "text": "Date", type: "Date" },
          { key: "view", "text": "View", type: "Date" },
        ],
        
        qFilter: { clientId: this.$route.params.id }
      };
    },
    
    methods: {
      
    },

    components: {
      EmbedApiTable
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/QuestionnaireTable.vue